<template>
  <div class="box" v-if="!loading">
    <div class="center" :class="{ 'content-box': !hideTop }">
      <div v-if="!hideTop" class="banner-box">
        <img :src="kvUrl" alt="" class="banner" />
      </div>
      <div class="form">
        <div class="form-item-box">
          <el-form ref="form" :model="formData" label-position="top">
            <el-form-item
              v-for="item in dataList"
              :key="item.fieldName"
              :label="
                (item.displayType === '3' &&
                  item.fieldName != 'ExpandStorageTime') ||
                item.displayType === '5' || (item.displayName.length>15)
                  ? item.displayName
                  : ''
              "
              :prop="item.fieldName"
              v-if="!item.isHide"
              :class="
                [
                  'ExpandStorageTime',
                  'StorageBudget',
                  'DetailRequirements'
                ].includes(item.fieldName)
                  ? 'labelrequired'
                  : item.required == '1'
                  ? 'labelrequired'
                  : ''
              "
            >
<!--              <span style="position: relative;left: -100px">{{item.fieldName}}</span>-->

              <el-input
                v-if="
                  item.displayType == '1' &&
                  item.fieldName === 'DetailRequirements'
                "
                type="textarea"
                v-model="formData[item.fieldName]"
              >
              </el-input>
              <el-input
                v-if="
                  item.displayType == '1' &&
                  item.fieldName !== 'DetailRequirements' &&
                    item.fieldName !== 'enterprise'
                "
                type="text"
                :class="item.required == '1' && (item.displayName.length<15) ? 'required' : ''"
                :placeholder="(item.displayName.length>15)?'请输入':item.displayName"
                v-model="formData[item.fieldName]"
              >
              </el-input>
              <el-autocomplete
                  v-if="
                  item.displayType == '1' &&
                  item.fieldName == 'enterprise'
                "
                  :class="item.required == '1' ? 'required' : ''"
                  :trigger-on-focus="false"
                  v-model="formData[item.fieldName]"
                  :fetch-suggestions="querySearchAsync"
                  @blur="blurCompany"
                  :placeholder="item.displayName"
                  @select="handleSelect"
              ></el-autocomplete>
              <div class="province" v-if="item.fieldName === 'province'">
                <el-select
                  :placeholder="item.displayName"
                  v-model="formData[item.fieldName]"
                  :popper-class="formData[item.fieldName] ? 'myselected' : ''"
                  :class="item.required == '1' ? 'required' : ''"
                >
                  <el-option
                    v-for="items in item.dictInfo"
                    :key="items.dicID"
                    :label="items.name"
                    :value="items.name"
                    @click.native="
                      city = items.child[Object.keys(items.child)];
                      formData.city = '';
                    "
                  ></el-option>
                </el-select>
                <el-select
                  placeholder="城市"
                  :popper-class="formData.city ? 'myselected' : ''"
                  v-model="formData.city"
                  :class="{
                    required: item.required == '1',
                    diabled: formData[item.fieldName].length == 0
                  }"
                  :disabled="formData[item.fieldName].length == 0"
                >
                  <el-option
                    v-for="items in city"
                    :key="items.dicID"
                    :label="items.name"
                    :value="items.name"
                  ></el-option>
                </el-select>
              </div>

              <el-select
                v-else-if="
                  item.fieldType === 'LIST' &&
                  item.displayType === '4' &&
                  !['ExpandStorageTime', 'StorageBudget'].includes(
                    item.fieldName
                  )
                "
                :class="item.required == '1' ? 'required' : ''"
                :popper-class="formData[item.fieldName] ? 'myselected' : ''"
                :placeholder="item.displayName"
                v-model="formData[item.fieldName]"
              >
                <el-option
                  v-for="items in item.dictInfo"
                  :key="items.dicID"
                  :label="items.name"
                  :value="items.name"
                ></el-option>
              </el-select>
              <div
                class="extraConfig"
                v-if="item.fieldType === 'DESC'"
                v-html="item.extraConfig.htmlContent"
              ></div>

              <el-radio-group
                v-if="
                  item.fieldType === 'LIST' &&
                  item.displayType === '3' &&
                  !['ExpandStorageTime', 'StorageBudget'].includes(
                    item.fieldName
                  )
                "
                v-model="formData[item.fieldName]"
                @change="changeRadio(item)"
              >
                <el-radio
                  v-for="items in item.listOptions"
                  :key="items.id"
                  :label="items.optionValue"
                ></el-radio>
              </el-radio-group>

              <el-select
                v-else-if="
                  ['ExpandStorageTime', 'StorageBudget'].includes(
                    item.fieldName
                  )
                "
                :class="item.required == '1' ? 'required' : ''"
                :popper-class="formData[item.fieldName] ? 'myselected' : ''"
                :placeholder="item.displayName"
                v-model="formData[item.fieldName]"
              >
                <el-option
                  v-for="items in item.listOptions"
                  :key="items.id"
                  :label="items.optionValue"
                  :value="items.optionValue"
                ></el-option>
              </el-select>
              <el-checkbox-group
                v-if="item.fieldType === 'LIST' && item.displayType === '5'"
                v-model="formData[item.fieldName]"
              >
                <el-checkbox
                  v-for="d in item.listOptions"
                  :key="d.id"
                  :checked="d.checked"
                  :label="d.optionValue"
                  @change="changeSelect(item)"
                >
                  {{ d.optionValue }}
                </el-checkbox>
              </el-checkbox-group>
              <div class="yinsi" v-if="item.fieldName === 'privacyPolicy'">
                <span class="ysrequire" style="">*</span>
                <el-checkbox v-model="formData[item.fieldName]">
                  <span class="ystxt" v-html="item.privacyPolicyTitle"></span>
                </el-checkbox>
              </div>
              <div
                class="phone-code"
                v-if="item.fieldName == 'mobile' && isSendSms"
              >
                <el-form-item>
                  <div style="display: flex">
                    <el-input
                      v-model="phonecode"
                      type="text"
                      :class="item.required == '1' ? 'required' : ''"
                      placeholder="验证码"
                    >
                    </el-input>
                    <el-button
                      type="primary"
                      @click="getCode"
                      :disabled="phonedisabled"
                      class="code"
                      >{{ codeText }}</el-button
                    >
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
          </el-form>
          <div class="footer">
            <el-button
              class="btn"
              type="primary"
              @click="onSubmit"
              v-loading="isSubDis"
              >提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import url from '@/plugins/url';

export default {
  name: 'Index',

  data() {
    return {
      customFormId: url.GetQueryString('customFormId'),
      globalUserId: this.$store.state.userInfo.globalUserId,
      id: url.GetQueryString('customFormId'),
      linkId: url.GetQueryString('linkId'),
      tenantId: this.$store.state.userInfo.tenantId,
      instanceId: this.$store.state.userInfo.instanceId,
      moduleId: this.$store.state.userInfo.moduleId,
      hideTop: false,
      kvUrl: '',
      wapkvUrl: '',
      configId: '',
      weChatId: '',
      dataList: '',
      city: [],
      formData: {
        city: []
      },
      customFormInfo: {},
      loading: true,
      isYinsi: false,
      isSendSms: false,
      phonedisabled: false,
      codeText: '获取验证码',
      phonecode: '',
      isSubDis: false,
      comlist:[],
      industrys:[],
      currentComName:""
    };
  },
  watch:{
    "formData.province"(newVal,oldVal){
      console.log(newVal)
      if(newVal){
        this.dataList.forEach((list) => {
           if(list.displayName=='您希望参加线下技术交流会的具体城市是：'){
             this.formData[list.fieldName]=newVal
           }
        });
      }
    },
    "formData.city"(newVal,oldVal){
      if(newVal){
        this.dataList.forEach((list) => {
          if(list.displayName=='您希望参加线下技术交流会的具体城市是：'){
            this.formData[list.fieldName]=this.formData.province+newVal
          }
        });
      }
    }
  },
  created() {
    console.log(url.GetQueryString('hideTop'));
    if (url.GetQueryString('hideTop')) {
      this.hideTop = true;
    }
    this.initFontSize();
    this.getForm();
  },
  mounted() {
    this.customFormBrowse();
    this.customFormView();
  },

  methods: {
    querySearchAsync(queryString, cb){
      var restaurants = this.comlist;
      if(!queryString){
        return
      }
      this.$api.getCompanyQuery({keyword:queryString}).then(res=>{
        let list=[];
        res.data.forEach(item=>{
          list.push({value:item.companyName})
        })
        cb(list);
      })
    },
    blurCompany(){
      if(this.formData.enterprise && this.formData.enterprise !==this.currentComName){
        this.handleSelect({value:this.formData.enterprise})
      }
    },
    handleSelect(data,callback){
     if(!data.value){
       return;
     }
     this.currentComName=data.value
      this.$api.getCompanyData({company:data.value}).then(res=>{
        console.log(res)
        if(res.data.length===0){
          res.data={}
        }
        let isIndustry=true
       if(res.data.industry){
         this.industrys.forEach(item=>{
           if(item.name===res.data.industry){
             isIndustry=false
           }
         })
       }
        this.dataList.forEach((item,index)=>{
          if(item.fieldName==='province'){
            if( res.data.province && res.data.city){
              this.formData[item.fieldName]=res.data.province;
              item.dictInfo.forEach(itm=>{
                if(itm.name===res.data.province){
                  this.city=   itm.child[Object.keys(itm.child)]
                }
              })
              if(res.data.city){
                this.formData['city']=res.data.city;
              }
            }else{

            }
          }

          if(item.displayName==='经营状态'){
            this.formData[item.fieldName]=res.data.regStatus;
          }
          if(item.displayName==='营业收入'){
            this.formData[item.fieldName]=res.data.totalSales;
          }
          if(item.displayName==='人员规模'){
            this.formData[item.fieldName]=res.data.staffNumRange;
          }
          if(!data.isSub){
            if(item.fieldName==='industry'){
              if(!isIndustry){
                // this.formData[item.fieldName]=res.data.industry;
                // item.isHide=true;
                this.$set(this.formData,item.fieldName,res.data.industry)
                this.$set(this.dataList[index],'isHide',true)
              }else{
                // this.formData[item.fieldName]='';
                // item.isHide=false;
                this.$set(this.formData,item.fieldName,'')
                this.$set(this.dataList[index],'isHide',false)
              }
            }
          }

        })
        callback && callback()
      })
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    getCode() {
      if (!this.formData['mobile']) {
        this.$message.error('手机号不能为空');
        return;
      }
      //验证手机号
      if (!/^1[3456789]\d{9}$/.test(this.formData['mobile'])) {
        this.$message.error('手机号格式不正确');
        return;
      }
      this.phonedisabled = true;
      this.$api
        .sendCode({
          mobile: this.formData['mobile'],
          customFormId: this.customFormId,
          globalUserId: this.globalUserId
        })
        .then((res) => {
          this.codeText = '60s';
          let timer = setInterval(() => {
            let num = parseInt(this.codeText) - 1;
            if (num === 0) {
              clearInterval(timer);
              this.phonedisabled = false;
              this.codeText = '获取验证码';
            } else {
              this.codeText = num + 's';
            }
          }, 1000);
        });
    },
    initFontSize() {
      if (document.documentElement.getBoundingClientRect().width <= 750) {
        document.documentElement.style.fontSize =
          (document.documentElement.getBoundingClientRect().width / 750) * 100 +
          'px';
      }
    },
    async getForm() {
      const data = {
        customFormId: this.customFormId,
        globalUserId: this.globalUserId,
        id: this.id,
        tenantId: this.tenantId
      };
      let arr = await this.$api.acquireFormAPI(data);
      let formData = {
        city: ''
      };
      var hideField=['经营状态','营业收入','人员规模','您希望参加线下技术交流会的具体城市是：'];
      arr.content.items.forEach((item) => {
        if (
          item.fieldName == 'DetailRequirements' ||
          item.fieldName == 'ExpandStorageTime' ||
          item.fieldName == 'StorageBudget'
        ) {
          item.isHide = true;
          item.required = 0;
        }
        if (item.displayType != '9') {
          if (item.displayType == '5') {
            if (item.fieldName == 'Relevantinformation') {
              formData[item.fieldName] = [
                '我希望通过电子邮件接收联想凌拓的相关资讯',
                '我希望通过电话接收联想凌拓的相关资讯'
              ];
            } else {
              formData[item.fieldName] = [];
            }
          } else {
            formData[item.fieldName] = '';
          }
        }
        if (item.fieldName == 'privacyPolicy') {
          this.isYinsi = true;
          formData[item.fieldName] = !!item.isSelected;
        }
        if (item.fieldName == 'mobile') {
          this.isSendSms = item.isSendSms;
        }
        if(hideField.indexOf(item.displayName)>-1){
          item.isHide=true
        }

        if(item.fieldName==='industry'){
          this.industrys=item.dictInfo
        }
      });
      document.title = arr.content.shareTitle;
      this.formData = JSON.parse(JSON.stringify(formData));
      console.log( arr.content.items)

      this.dataList = arr.content.items;
      this.customFormInfo = arr.content;
      this.checkRegistration();
      this.configId = this.customFormInfo.template.pc.configId;
      this.getFormConfig();
      console.log('customFormInfo', this.customFormInfo);
    },

    changeRadio(item) {
      console.log(item);
      console.log(this.formData[item.fieldName])
      if (item.fieldName == 'NeedSalesContactImmediately') {
        this.dataList.forEach((list) => {
          if (list.fieldName == 'DetailRequirements') {
            if (this.formData.NeedSalesContactImmediately == '是') {
              list.isHide = false;
              list.required = 1;
            } else {
              list.isHide = true;
              list.required = 0;
            }
          }
        });
      }
      if(item.displayName=='您是否希望参加，与本期技术交流会相同主题的，线下面对面的技术交流会？'){
          this.dataList.forEach((list) => {
            if (list.displayName == '您希望参加线下技术交流会的具体城市是：') {
              if (this.formData[item.fieldName] == '是') {
                list.isHide = false;
                list.required = 1;
              } else {
                list.isHide = true;
                list.required = 0;
              }
            }
          });
      }
    },
    changeSelect(item) {
      console.log(item);
      console.log(this.formData[item.fieldName]);
      if (item.fieldName == 'StorageNeed') {
        this.dataList.forEach((list) => {
          if (
            list.fieldName == 'ExpandStorageTime' ||
            list.fieldName == 'StorageBudget'
          ) {
            list.isHide =
              !this.formData.StorageNeed.length ||
              (this.formData.StorageNeed.length == 1 &&
                this.formData.StorageNeed[0] === '暂无')
                ? true
                : false;
            list.required = list.isHide ? 0 : 1;
          }
        });
      }
    },
    // 浏览
    customFormView() {
      this.$api.customFormView({
        customFormId: this.customFormId,
        globalUserId: this.globalUserId,
        linkId: this.linkId,
        memberId: '',
        openId: '',
        referenceUrl: '',
        sess: '',
        tenantId: this.tenantId,
        url: '',
        weChatId: ''
      });
    },
    // 浏览
    customFormBrowse() {
      this.$api.customFormBrowse({
        customFormId: this.customFormId,
        globalUserId: this.globalUserId,
        openId: '',
        sess: '',
        tenantId: this.tenantId
      });
    },
    // 获取是否报过名
    checkRegistration() {
      this.$api
        .checkRegistration({
          customFormId: this.customFormId,
          globalUserId: this.globalUserId,
          instanceId: this.instanceId,
          openId: '',
          tenantId: this.tenantId
        })
        .then((res) => {
          if (this.moduleId != '2' && this.moduleId != '3') {
            if (res.content.signupStatus == 'notAllow') {
              this.submitAfter();
            }
          }
        });
    },
    // 获取模板配置信息
    getFormConfig() {
      this.$api
        .getFormConfig({
          configId: this.configId,
          globalUserId: this.globalUserId,
          tenantId: this.tenantId
        })
        .then((res) => {
          this.kvUrl =
            res.content.configInfo.html[0].extra[1].extras[0].extras[1].src.value;
          this.loading = false;
          this.$nextTick(() => {
            let height = document.body.scrollHeight;
            window.parent.postMessage(
              {
                action: 'documentHeight',
                height: height
              },
              '*'
            );
          });
        });
    },
    isValid() {
      debugger
      let valid = false;
      let hasCity = false;
      for (let i = 0; i < this.dataList.length; i++) {

        if (this.dataList[i].required == '1') {
          if (this.dataList[i].fieldName == 'province') {
            hasCity = true;
          }
          if (
            this.dataList[i].fieldName == 'mobile' ||
            this.dataList[i].fieldName == 'email'
          ) {
            if (this.formData[this.dataList[i].fieldName]) {
              if (
                !new RegExp(this.dataList[i].regularExpression).test(
                  this.formData[this.dataList[i].fieldName]
                )
              ) {
                alert(`请输入正确的${this.dataList[i].displayName}`);
                valid = true;
                break;
              }
            } else {
              alert(`请输入您的${this.dataList[i].displayName}`);
              valid = true;
              break;
            }
          } else {
            console.log(this.formData)
            console.log(this.dataList[i])
            console.log(this.formData[this.dataList[i].fieldName])
            console.log('-------')
            if (this.formData[this.dataList[i].fieldName].length == 0) {
              alert(`请输入您的${this.dataList[i].displayName}`);
              valid = true;
              break;
            }
          }
        }
      }
      if (!valid) {
        if (hasCity && this.formData.city.length == 0) {
          alert(`请选择您的城市`);
          valid = true;
        }
      }
      if (!valid && !this.phonecode && this.isSendSms) {
        this.$message({
          message: '请输入验证码！',
          type: 'warning'
        });
        valid = true;
      }
      if (!valid && !this.formData['privacyPolicy'] && this.isYinsi) {
        this.$message({
          message: '请勾选隐私政策',
          type: 'warning'
        });
        valid = true;
      }

      return valid;
    },
    onSubmit(isSub) {
      let isVa = this.isValid();
      let submitData = [];
      if (!isVa) {
        this.dataList.forEach((item) => {
          if (item.fieldType === 'LIST') {
            if (item.displayType === '3' || item.displayType === '4') {
              if (item.fieldName == 'province') {
                submitData.push({
                  fieldName: item.fieldName,
                  value: [this.formData.province, this.formData.city]
                });
              } else {
                submitData.push({
                  fieldName: item.fieldName,
                  value: [this.formData[item.fieldName]]
                });
              }
            } else {
              if (item.displayType === '5') {
                submitData.push({
                  fieldName: item.fieldName,
                  value: this.formData[item.fieldName]
                });
              }
            }
          } else {
            if (item.displayType != '9') {
              submitData.push({
                fieldName: item.fieldName,
                value: this.formData[item.fieldName]
              });
            }
          }
        });
        if (this.isSubDis) {
          return;
        }
        this.isSubDis = true;
        // 请求完获取企业信息在提交
        if(isSub!=1){
          this.handleSelect({value:this.formData.enterprise,isSub:1},res=>{
            this.isSubDis = false;
            this.onSubmit(1)
          })
          return;
        }
        this.$api
          .customFormAction({
            customFormId: this.customFormId,
            globalUserId: this.globalUserId,
            instanceId: this.instanceId,
            items: submitData,
            linkId: this.linkId,
            openId: '',
            referenceUrl: '',
            sess: '',
            session: '',
            verificationCode: this.phonecode,
            url: window.location.href,
            signPointItems: [],
            tenantId: this.tenantId,
            ver: 'v2.0.1'
          })
          .then(
            (res) => {
              this.isSubDis = false;
              if (res.result == '0') {
                this.submitAfter();
              } else {
              }
            },
            (err) => {
              this.isSubDis = false;
              if (err.result == '200730') {
                let cnNameObj = {
                  mobile: '手机号',
                  email: '邮箱'
                };
                let string = '';
                err.content.repeatFields.forEach((item) => {
                  string = string + cnNameObj[item];
                });
                string += '字段内容已存在，请重新填写！';
                alert(string);
              } else {
                alert(err.desc);
              }
            }
          );
      }
      console.log('submitData=>', submitData);
      console.log('formData=>', this.formData);
    },
    submitAfter() {
      if (this.hideTop) {
        if (this.customFormInfo.completeActionType == '2') {
          window.parent.location.href = this.customFormInfo.completeAction;
        }
      } else {
        if (this.customFormInfo.completeActionType == '2') {
          window.location.href = this.customFormInfo.completeAction;
        }
      }
    }
  }
};
</script>
<style>
@media screen and (min-width: 750px) {
}
.el-checkbox__input{
  vertical-align: top;
  margin-top: 5px;
}
.el-form .el-checkbox .el-checkbox__label{
  white-space: pre-wrap;
}
</style>
<style scoped>
@media screen and (max-width: 750px) {
  .yinsi {
    padding-left: 20px;
  }

  .yinsi ::v-deep .el-checkbox__input {
    top: 2px;
    position: absolute;
    left: -7px;
  }

  .yinsi .ysrequire {
    color: red;
    margin-right: 10px;
    top: 11px;
    position: absolute;
    left: 0;
  }
}

.ystxt {
  word-break: break-word;
  display: block;
  line-height: 1.5;
  white-space: pre-wrap;
}

.ysrequire {
  color: red;
  margin-right: 10px;
  top: 2px;
  position: relative;
}

.phone-code {
  margin-top: 22px;
}

.code {
  margin-left: 20px;
  width: 120px;
  background: #7f2854;
  border-color: #7f2854;
}

.code:hover {
  background: #7f2854;
  border-color: #7f2854;
}

.code:active,
.code:focus {
  background: #7f2854;
  border-color: #7f2854;
}

.code.is-disabled {
  background: #7f28547a;
  border-color: #7f28547a;
}

.code.is-disabled:hover {
  background: #7f28547a;
  border-color: #7f28547a;
}

.yinsi ::v-deep a {
  color: #7f2854;
}
</style>
